// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2HY2p","row":"ProcedureTreatmentSummary_row__T68tp"};